import { Injectable } from '@angular/core';
import { each, find, result } from 'lodash';

export interface IOptions {
  graphQlKey: string;
  parent: string;
  parentOrder: number;
  children: Array<{
    graphQlKey: string;
    child: string;
    childOrder: number;
  }>;
}

@Injectable()
export class VizMadLibService {
  getHumanKey(options: IOptions[], key: string): string {
    let match: string;
    match = result(
      find(options, (x: any) => {
        return x.graphQlKey === key;
      }),
      'parent',
    );
    if (!match) {
      each(options, (option: any) => {
        let suboptionMatch = find(option.children, (x: any) => {
          return x.graphQlKey === key;
        });
        if (suboptionMatch) {
          match = result(suboptionMatch, 'child');
        }
      });
    }
    return match;
  }
}
